<div class="min-h-screen bg-slate-50 font-sans text-slate-800 relative flex flex-col">
  <app-header area="header" *ngIf="ui.navegacion" [buscador]="ui.buscador"></app-header>
  <main area="main" class="flex-grow">
    <router-outlet></router-outlet>
  </main>
  <app-footer area="footer" *ngIf="ui.pie"></app-footer>

  <div class="floating-actions" *ngIf="ui.flotantes">
    <app-subir *ngIf="scrolled"></app-subir>
    <app-whatsapp *ngIf="ui.whatsapp && esHorarioOficina"
      [phone]="5216692705424"
      message="Hola, ¿Podrían ayudarme?"></app-whatsapp>
  </div>

  @if (ui.flotantes) {
    @defer (on idle) {
      <app-chatbot></app-chatbot>
    }
  }
  <app-compatible></app-compatible>
</div>

